import { render, staticRenderFns } from "./linkPage.vue?vue&type=template&id=6b28cf6a&scoped=true"
import script from "./linkPage.vue?vue&type=script&lang=js"
export * from "./linkPage.vue?vue&type=script&lang=js"
import style0 from "./linkPage.vue?vue&type=style&index=0&id=6b28cf6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b28cf6a",
  null
  
)

export default component.exports